import { Component } from '@verndale/core';
import Swiper, { Navigation, Scrollbar } from 'swiper';
import { breakpoints } from '../helpers/constants';

Swiper.use([Navigation, Scrollbar]);

class FlexibleCarousel extends Component {
  setupDefaults() {
    this.dom = {
      wideSliderContainer: this.el.querySelector(
        '.flexible-carousel__container--wide'
      ),
      tallSliderContainer: this.el.querySelector(
        '.flexible-carousel__container--tall'
      ),
      scroll: this.el.querySelector('.swiper-scrollbar'),
      nextBtn: this.el.querySelector('.swiper-button-next'),
      prevBtn: this.el.querySelector('.swiper-button-prev'),
      cards: this.el.querySelectorAll('.cta-description-card'),
      sliderWrapper: this.el.querySelector('.swiper-wrapper'),
      controlsContainer: this.el.querySelector('.controls-btns')
    };
    this.initSlider();
    this.hideControls();
  }

  addListeners() {
    const { cards } = this.dom;

    cards.forEach(card =>
      card.addEventListener('mouseover', ::this.onHoverCard)
    );
    cards.forEach(card =>
      card.addEventListener('mouseleave', ::this.onLeaveCard)
    );
    window.addEventListener('resize',  () => this.hideControls())
  }

  initSlider() {
    const {
      tallSliderContainer,
      wideSliderContainer,
      nextBtn,
      prevBtn,
      scroll,
      cards,
      controlsContainer
    } = this.dom;

    if (cards.length < 2) controlsContainer.style.display = 'none';

    const slider = new Swiper(
      tallSliderContainer ? tallSliderContainer : wideSliderContainer,
      {
        slidesPerView: 1.3,
        spaceBetween: 22,
        scrollbar: {
          el: scroll,
          draggable: true
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          [breakpoints.tablet]: {
            slidesPerView: tallSliderContainer ? 4.2 : 2.3,
            spaceBetween: 20
          },
          [breakpoints.tabletLandscape]: {
            slidesPerView: tallSliderContainer ? 4.3 : 2.3,
            spaceBetween: 24
          },
          [breakpoints.laptop]: {
            slidesPerView: tallSliderContainer ? 4 : 2,
            spaceBetween: 32
          },
          [breakpoints.desktop]: {
            slidesPerView: tallSliderContainer ? 4 : 2,
            spaceBetween: 40
          },
          [breakpoints.wide]: {
            slidesPerView: tallSliderContainer ? 4 : 2,
            spaceBetween: 48
          },
          [breakpoints.fullHd]: {
            slidesPerView: tallSliderContainer ? 4 : 2,
            spaceBetween: 68
          }
        },
        on: {
          resize: swiper => {
            swiper.update();
          }
        }
      }
    );
  }

  changeControlsDisplay(display) {
    this.dom.controlsContainer.style.display = display;
  }

  hideControls() {
    if (this.dom.tallSliderContainer) {
      if (window.innerWidth >= breakpoints.tablet && this.dom.cards.length <= 4) {
        return this.changeControlsDisplay('none')
      } else if (window.innerWidth < breakpoints.tablet && this.dom.cards.length < 2) {
        return this.changeControlsDisplay('none')
      }
      return this.changeControlsDisplay('flex')
    } else if (this.dom.wideSliderContainer) {
      if (window.innerWidth >= breakpoints.tablet && this.dom.cards.length <= 2) {
        return this.changeControlsDisplay('none')
      } else if (window.innerWidth < breakpoints.tablet && this.dom.cards.length < 2) {
        return this.changeControlsDisplay('none')
      }
      return this.changeControlsDisplay('flex')
    }
  }

  onHoverCard(e) {
    const { cards } = this.dom;
    cards.forEach(
      card => !card.contains(e.target) && card.classList.add('light-opacity')
    );
  }

  onLeaveCard(e) {
    const { cards } = this.dom;
    cards.forEach(
      card => !card.contains(e.target) && card.classList.remove('light-opacity')
    );
  }
}

export default FlexibleCarousel;
